import type { Ref } from "react";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { IconButton, Tooltip } from "@mui/material";

interface Props {
  ref?: Ref<HTMLButtonElement>;
  show: boolean;
  onClick?: () => void;
}

const FieldItemShowOnGridButton = ({ ref, ...props }: Props) => {
  const { show, onClick, ...others } = props;
  return (
    <Tooltip title="Show On Grid" placement="bottom" arrow disableInteractive>
      <IconButton
        ref={ref}
        sx={{ height: "28px", width: "28px", visibility: show ? "visible" : "hidden" }}
        onClick={onClick}
        {...others}
      >
        <ArrowForwardRoundedIcon sx={(theme) => ({ color: theme.palette.secondary.light })} />
      </IconButton>
    </Tooltip>
  );
};

export default FieldItemShowOnGridButton;
